import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ISiteAccountParamsApiListResponse, ISiteAccountParamUpdateParams, ISiteAccountParamUpdateResponse } from '@/types/siteAccountParams';

export const siteAccountParamsList = (accountId: number, config?: AxiosRequestConfig): Promise<AxiosResponse<ISiteAccountParamsApiListResponse>> => {
    return axios.get('/api/siteAccountParams/list', {
        ...config,
        params: { accountParamsAccountId: accountId },
    });
};

export const siteAccountParamsCreate = (params: ISiteAccountParamUpdateParams): Promise<AxiosResponse<ISiteAccountParamUpdateResponse>> => {
    return axios.post('/api/siteAccountParams/create', params);
};

export const siteAccountParamsUpdate = (params: ISiteAccountParamUpdateParams): Promise<AxiosResponse<ISiteAccountParamUpdateResponse>> => {
    return axios.post('/api/siteAccountParams/update', params);
};

export const siteAccountParamsDelete = (params: ISiteAccountParamUpdateParams): Promise<AxiosResponse<ISiteAccountParamUpdateResponse>> => {
    return axios.post('/api/siteAccountParams/delete', params);
};
